import { Container } from './styled';

export default function Item({ children, xs, lg }) {
  return (
    <Container xs={xs || 12} lg={lg || 12}>
      {children}
    </Container>
  );
}
